/* eslint-disable react/prop-types */
import assign from 'lodash/assign';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';

import RatingAndReviewActions from '../../../../flux/actions/RatingAndReviewActions';
import pathsManifest from '../../../../pathsManifest';
import queryUtil from '../../../../utils/queryUtils';

import TenantSelector from './TenantSelector';

class PropertyRatingAndReviewTenantPage extends React.Component {
  constructor(props) {
    super(props);
  }

  redirectToRatingAndReviewPage = (tenantType) => {
    const { dispatch, routingLocation } = this.props;

    dispatch(RatingAndReviewActions.editTenantType(tenantType));

    const query = assign({}, queryUtil.parse(routingLocation.search), {
      tenantType,
    });
    const queryString = queryUtil.stringify(query);

    dispatch(push(pathsManifest.propertyRatingAndReviewRatePage + queryString));
  };

  render() {
    const { currentListing } = this.props;

    return <TenantSelector address={currentListing.address} onNext={this.redirectToRatingAndReviewPage} />;
  }
}

const mapStateToProps = (state) => ({
  routingLocation: state.router.location,
  currentListing: state.ratingAndReview.listing,
});

export default connect(mapStateToProps)(PropertyRatingAndReviewTenantPage);
